import React, { FC, ReactNode } from 'react';
import cn from 'classnames';
import NextImage from 'src/shared-components/NextImage/NextImage';
import { FormattedMessage } from 'react-intl';
import trns from '../trns';

const heartOutlinedIcon = 'shared/heart-outlined.svg';

const locationIcon = 'shared/location.svg';
const loyaltyIcon = 'shared/loyalty.svg';
const trolleyIcon = 'shared/trolley.svg';

const TradenameCategoryBannerItem: FC<{
  alt: string;
  src: string;
  children: ReactNode;
}> = ({ alt, src, children }) => {
  return (
    <div className="flex items-end gap-3">
      <NextImage
        className="hidden m:flex"
        alt={alt}
        src={src}
        layout="fixed"
        height={29}
        width={29}
      />
      <p className="text-gray900 fs-body-bold text-center">{children}</p>
    </div>
  );
};

interface Props {
  className?: string;
}

const TradenameCategoryBanner: FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        className,
        'flex justify-between w-full my-6 py-4 px-4 m:px-6',
        'rounded-lg',
        'bg-gradient-to-r from-[#D9E3FF] via-[#E1EAFF] to-[#E3F5FA]'
      )}
    >
      <div>
        <p className="text-bahamaBlue text-left fs-header5-bold">
          <FormattedMessage {...trns.findDrugsNearby} />
        </p>

        <div className="flex justify-between mt-6">
          <TradenameCategoryBannerItem alt="location" src={locationIcon}>
            <FormattedMessage
              {...trns.pharmacies}
              values={{
                quantity: (
                  <span className="text-bahamaBlue text-left fs-header5-bold">
                    6 700
                  </span>
                )
              }}
            />
          </TradenameCategoryBannerItem>

          <TradenameCategoryBannerItem alt="loyalty.svg" src={loyaltyIcon}>
            <FormattedMessage
              {...trns.economy}
              values={{
                percents: (
                  <span className="text-bahamaBlue text-left fs-header5-bold">
                    40%
                  </span>
                )
              }}
            />
          </TradenameCategoryBannerItem>

          <TradenameCategoryBannerItem alt="trolley" src={trolleyIcon}>
            <FormattedMessage
              {...trns.goods}
              values={{
                quantity: (
                  <span className="text-bahamaBlue text-left fs-header5-bold">
                    67 000
                  </span>
                )
              }}
            />
          </TradenameCategoryBannerItem>
        </div>
      </div>
      <div className="hidden m:flex lm:hidden l:flex items-center">
        <NextImage
          alt="heart-outlined"
          src={heartOutlinedIcon}
          layout="fixed"
          height={54}
          width={54}
        />
      </div>
    </div>
  );
};

export default TradenameCategoryBanner;
